import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CognitoService } from '../core/services/cognito/cognito.service';

@Injectable({
  providedIn: 'root',
})
export class PreventBackButtonGuard implements CanActivate {
  constructor(private router: Router, private cognito: CognitoService) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.cognito.usuarioLogado()) {
      this.router.navigate(['/usuario']).catch((error) => console.log(error));
      return false;
    }
    return true;
  }
}
